exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item-shadow[data-v-b06fbe3c]{position:absolute;top:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-top:-40px;margin-left:-40px;width:80px;height:80px;pointer-events:none;z-index:10}.item-shadow-texture[data-v-b06fbe3c]{width:100%;height:100%;border:1px solid #888;background-color:#6f6;opacity:.75}.item-shadow-texture .item-shadow-texture-img[data-v-b06fbe3c]{width:100%;height:100%;background-size:20px 20px;opacity:.25}.item-shadow-image[data-v-b06fbe3c]{background-color:#6f6;opacity:.75}.item-shadow-image img[data-v-b06fbe3c]{opacity:.25}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b06fbe3c","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./assets/js/components/ItemShadow.vue
// module id = 568
// module chunks = 0